// src/utils/charts/options.ts
import type { XAXisComponentOption, YAXisComponentOption, GridComponentOption, DataZoomComponentOption } from "echarts";
export interface ChartTheme {
  axisLine?: string;
  axisLabel?: string;
  splitLine?: string;
}

const DEFAULT_THEME: Required<ChartTheme> = {
  axisLine: "#4b5563",
  axisLabel: "#9ca3af",
  splitLine: "rgba(148, 163, 184, 0.15)",
};

export function buildGrid(options?: { top?: number; right?: number; bottom?: number; left?: number; containLabel?: boolean }): GridComponentOption {
  const { top = 24, right = 16, bottom = 32, left = 16, containLabel = true } = options || {};
  return { top, right, bottom, left, containLabel };
}

export function buildTimeAxis(theme?: ChartTheme): XAXisComponentOption {
  const t = { ...DEFAULT_THEME, ...(theme || {}) };
  return {
    type: "time",
    axisLine: { lineStyle: { color: t.axisLine } },
    axisLabel: { color: t.axisLabel },
    splitLine: { show: false },
  };
}

export function buildValueAxis(
  name: string,
  options?: { position?: "left" | "right"; formatter?: (v: number | string) => string; theme?: ChartTheme }
): YAXisComponentOption {
  const { position = "left", formatter, theme } = options || {};
  const t = { ...DEFAULT_THEME, ...(theme || {}) };
  return {
    type: "value",
    name,
    position,
    axisLine: { lineStyle: { color: t.axisLine } },
    axisLabel: {
      color: t.axisLabel,
      ...(formatter ? { formatter } : {}),
    },
    splitLine: { lineStyle: { color: t.splitLine } },
  };
}

export function buildInsideZoom(options?: { start?: number; end?: number }): DataZoomComponentOption[] {
  const { start, end } = options || {};
  return [
    {
      type: "inside",
      zoomOnMouseWheel: true,
      moveOnMouseMove: true,
      moveOnMouseWheel: true,
      preventDefaultMouseMove: true,
      ...(start != null ? { start } : {}),
      ...(end != null ? { end } : {}),
    },
  ];
}


